<div class="p-grid p-jc-center p-mt-3">
    <div class="p-col-10">
        <h1 class="text-center">{{'GLOBAL.INTRO.PAGINA.PRINCIPAL.TITULO' |translate}}</h1>
    </div>
</div>
<div class="p-grid p-mt-6 p-jc-center">
    <div class="p-col-6">
        <h5 class="text-center">{{'GLOBAL.INTRO.PAGINA.PRINCIPAL.SUBTITULO' |translate}}</h5>
    </div>
</div>
<div class="p-grid p-mb-6 p-jc-center">
    <div class="p-md-2">
        <a href="https://play.google.com/store/" target="_blank">
            <img src="assets/imagenes/googlePlay.png" alt="" class="img-fluid">
        </a>
    </div>
    <div class="p-md-2">
        <a href="https://www.apple.com/es/ios/app-store/" target="_blank">
            <img src="assets/imagenes/appStore.png" alt="" class="img-fluid">
        </a>
    </div>
</div>

    <div class="p-grid p-jc-between">
        <div class="p-xl-6">
                <!--SECCION 1-->
    <div class="p-grid p-jc-between">
        <div class="p-xl-12 p-p-5 border-section-left">
                <h2 class="text-center p-mt-4">{{'GLOBAL.SECCION1.PAGINA.PRINCIPAL.TITULO' |translate}}</h2>
                <h4 class="text-center">{{'GLOBAL.SECCION1.PAGINA.PRINCIPAL.SUBTITULO' |translate}}</h4>
        </div>
    </div>
    <div class="p-grid p-jc-between nmtt">
        <div class="p-xl-12 border-section-left text-center p-mb-5">
            <img src="assets/imagenes/Facil_1200x1200.jpg" alt="" class="img-fluid">
            <div class="block"></div>
        </div>
    </div>
        </div>
        <div class="p-xl-6 seccion2">
            <!--SECCION 2-->
            <div class="p-grid p-jc-end">
                <div class="p-xl-12 main-seccion2 border-section-right">
                    <h2 class="text-center p-mt-4">{{'GLOBAL.SECCION2.PAGINA.PRINCIPAL.TITULO' |translate}}</h2>
                        <h4 class="text-center">{{'GLOBAL.SECCION2.PAGINA.PRINCIPAL.SUBTITULO' |translate}}</h4>
                </div>
            </div>
            <div class="p-grid p-jc-end">
                <div class="p-xl-12 border-section-right text-center p-mb-5 nmt">
                    <img src="assets/imagenes/Comoda_1200x1200.jpg" alt="" class="img-fluid">
                    <div class="block"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-grid main-como-funciona p-shadow-5 p-p-3">
        <div class="p-xl-12">
            <div class="p-grid p-jc-center">
                <div class="p-xl-12">
                    <h1 class="text-center">{{'GLOBAL.SECCION3.PAGINA.PRINCIPAL.TITULO' |translate}}</h1>
                </div>
            </div>  
            <div class="p-grid p-jc-center p-ai-center">
                <div class="p-xl-7 text-center center-area">
                    <img src="assets/imagenes/Funciona_1200x1200.jpg" alt="" class="img-fluid">
                    <div class="block"></div>
                </div>
            </div>
        </div>
    </div>
   <div class="p-grid p-jc-center">
        <div class="p-col-8">
            <div class="preguntas-frecuentes p-d-flex p-jc-center" (click)="goToPreguntasFrecuentes()">
                <span>{{'GLOBAL.PREGUNTAS.FRECUENTES' |translate}}</span>
            </div>
        </div>
   </div>
   <div class="p-mb-6">
    <h2 class="titulo-ultimas-noticias">Últimas noticias</h2>
    <dum-carousel-noticias></dum-carousel-noticias>
   </div>
